/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ComponentReference from './ComponentReference';
import NodeCollection from './NodeCollection';
import ReferencedComponent from './ReferencedComponent';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass
export default class NodeCollectionMember extends ReferencedComponent
{
    /** Whether instance of component is injectable. */
    @property({ override: true, visible: true })
    protected _isActive: boolean = true;

    @property
    protected set consumeReferenced(value: boolean) { this.consumeReferencedComponent(); }
    protected get consumeReferenced(): boolean { return false; }

    private consumeReferencedComponent(): void
    {
        if (!CC_EDITOR) { return; }
        const referencedComponent: ReferencedComponent
            = this.getComponents(ReferencedComponent).find(comp => comp !== this);
        if (!referencedComponent) { return; }

        this.IsActive = referencedComponent.IsActive;
        this.InstanceId = referencedComponent.InstanceId;
        this.ReferenceGroup = referencedComponent.ReferenceGroup;
        referencedComponent.destroy();
    }

    /** Add this component to the [[ComponentReference]] map. */
    public AddReference = (): void =>
    {
        if (!this._isActive || this.isAdded) { return; }

        let collectionRef: NodeCollection
            = ComponentReference.Get(NodeCollection, this.ReferenceGroup, this.InstanceId);

        if (!collectionRef)
        {
            collectionRef = (new cc.Node()).addComponent(NodeCollection);
            collectionRef.InstanceId = this.InstanceId;
            collectionRef.ReferenceGroup = this.ReferenceGroup;
            collectionRef.IsActive = true;
            collectionRef.AddReference();

            (cc.find('canvas') || this.node).addChild(collectionRef.node);
        }

        collectionRef.Nodes.push(this.node);
        this.isAdded = true;
    }
}
